import './supporter-identity.scss';

import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';

export const SupporterIdentity: React.FC<{
  variant: 'full' | 'minimal';
  name?: string;
  initials?: string;
  email?: string;
  notificationCount?: number;
}> = ({ variant, name, email, notificationCount, initials }) => {
  if (variant === 'minimal') {
    return (
      <div className="relative heading-sm label-potent">
        {initials || <ArkIcon iconName="user-01" />}
        {!!notificationCount && (
          <span className="label-sm label-potent flex justify-center items-center aspect-ratio-1 absolute">
            {notificationCount}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="flex gap-comfy-xs px-comfy-sm lg:px-comfy-xs">
      <div className="flex rounded-full SupporterIdentity__round shrink-0 items-center justify-center">
        <div className="label-xl label-potent">
          {initials || <ArkIcon iconName="user-01" />}
        </div>
      </div>
      <div className="flex flex-col overflow-hidden justify-center">
        {name && (
          <p className="SupporterIdentity__name label-md label-potent overflow-hidden m-0 text-wrap-nowrap text-ellipsis">
            {name}
          </p>
        )}
        {email && (
          <p className="SupporterIdentity__email label-md label-moderate overflow-hidden text-wrap-nowrap text-ellipsis">
            {email}
          </p>
        )}
      </div>
    </div>
  );
};
